import * as React from 'react'
import PageLayout from '../../layout/containers/PageLayout'
import { useTranslation } from 'react-i18next'
import { useAntdMessageApi } from '../../../providers'
import { useEffect } from 'react'
import { TermsOfUse } from '../components/TermsOfUse'

export const AcceptTermsOfUsePage = () => {
	const [t] = useTranslation()
	const messageApi = useAntdMessageApi()

	useEffect(() => {
		messageApi?.open({
			type: 'warning',
			content: t('core.privacyPolicy.explanation')
		})
	}, [messageApi, t])

	return <PageLayout renderMainContent={<TermsOfUse />} />
}
